export default "__VITE_ASSET__BKhWS7iV__"